import { render, staticRenderFns } from "./container-main.vue?vue&type=template&id=e850aa60&lang=pug&"
import script from "./container-main.vue?vue&type=script&lang=js&"
export * from "./container-main.vue?vue&type=script&lang=js&"
import style0 from "./container-main.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports